const {KitModule, registerModule} = window;

class CareersHero extends KitModule {
  constructor($element) {
    super($element);

    this.render = this.render.bind(this);

    this.setVars();
    this.bindEvents();
    this.animateIn();
    if (this.isDesktop) {
      this.handleFakeScroll();
    }
  }

  setVars() {
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.header = document.querySelector('[data-ref="SiteHeader"]');
    this.offset = this.$wordSlider.clientHeight;
    this.index = -1;
    this.timeout = 2000;
    this.lastIntervalTimestamp = 0;
    this.raf = undefined;
    this.isPlaying = false;
    this.nextSiblings = this.$element.nextElementSibling;

    // video
    this.video = this.$careerVideo.querySelector('video');
    this.careerBottomStartTop = this.$careerBottom.getBoundingClientRect().top;

    // scrolling animation
    this.scrollHeight = window.innerHeight * 2;
    this.scrollOffset = 0;
    this.scrollPercent = 0;
    this.indicatorPosition = this.scrollPercent;
    this.position = 0;
  }

  bindEvents() {
    window.addEventListener('resize', this);
    if (!this.isDesktop) {
      window.addEventListener('load', this);
    }
    window.addEventListener('scroll', this);
    this.$careerVideoButton.addEventListener('click', this);
  }

  animateIn() {
    if (this.header && this.isDesktop) {
      this.header.style.transform = 'translateY(-100%)';
    }
    setTimeout(() => {
      if (this.header && this.isDesktop) {
        this.header.style.transform = 'none';
      }
      document.body.classList.add('animate--on');
    }, 600);

    setTimeout(() => {
      this.render();
    }, 2000);
  }

  handleFakeScroll() {
    this.scrollOffset = window.pageYOffset || window.scrollTop;
    this.scrollPercent = this.scrollOffset / this.scrollHeight || 0;
    this.indicatorPosition += (this.scrollPercent - this.indicatorPosition) * 0.05;

    this.position = this.indicatorPosition * 300;

    if (this.position < 50) {
      this.$element.classList.remove('is-scrolling');
    }
    if (this.position > 100) {
      this.$element.classList.add('is-scrolling');
    }

    this.$careerTop.style.transform = `translateY(-${this.position}%)`;
    this.$careerBottom.style.transform = `translateY(${this.position}%)`;
    requestAnimationFrame(this.handleFakeScroll.bind(this));
  }

  onload() {
    this.video.play();
    this.isPlaying = true;
  }

  onresize() {
    this.scrollHeight = window.innerHeight * 4;
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  }

  onscroll() {
    this.scrollPos = window.scrollY;
    const {height} = this.$careerBottom.getBoundingClientRect();
    const {top} = this.nextSiblings.getBoundingClientRect();
    const targetPos = height / 2;

    if (this.scrollPos > targetPos && top > (window.innerHeight / 2)) {
      this.video.play();
      this.isPlaying = true;
    } else {
      this.video.pause();
      this.isPlaying = false;
    }
  }

  onclick() {
    this.video.muted = !this.video.muted;
    if (this.video.muted) {
      this.$careerVideo.classList.remove('mute');
    } else {
      this.$careerVideo.classList.add('mute');
    }
  }

  render(now) {
    if ((!this.lastIntervalTimestamp || now - this.lastIntervalTimestamp >= this.timeout)) {
      this.lastIntervalTimestamp = now;
      this.index++;

      this.animate(this.index);
    }

    if (this.index == this.$wordSlider.children.length - 1) {
      this.index = 0;
      this.lastIntervalTimestamp = 0;
      window.cancelAnimationFrame(this.raf);
      this.raf = undefined;
    } else {
      this.raf = window.requestAnimationFrame(this.render);
    }
  }

  animate(index) {
    this.$wordSlider.style.transform = `translateY(-${this.offset * index}px)`;
  }

  unmount() {
    this.classes.forEach((className) => {
      document.body.classList.remove(className);
    });
  }
}

registerModule('CareersHero', CareersHero);
